export const handleUnauthorized = (response) => {
    if (response.originalStatus === 401) {
        localStorage.removeItem('userInfo');
    }
};